import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { GET_STORE, SUPPLIERS_ROUTES } from '@wellbeingxltd/fe-lib/constants'
import { LoginLoader } from 'components'
import { AnalyticsActions } from 'store/models/analytics'
import SuppliersActions from 'store/models/supplier'

export const SUPPLIERS_STATUS = { COMPLETE: 'Complete', INCOMPLETE: 'Incomplete' }

function Onboarding() {
    const dispatch = useDispatch()
    const history = useHistory()
    const { loadingGetSupplier, supplier } = useSelector(GET_STORE.SUPPLIER)

    useEffect(() => {
        dispatch(SuppliersActions.getSupplier(history))
        dispatch(AnalyticsActions.postAnalytics('Login success', null))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!loadingGetSupplier && supplier?.status === SUPPLIERS_STATUS.COMPLETE) {
            const nextRoute = sessionStorage.getItem('redirectAfterLoginByLink')

            // Go to /transactions
            !nextRoute && !!history && history.push(SUPPLIERS_ROUTES.TRANSACTIONS.transactions)
            nextRoute && history.push(nextRoute)
            sessionStorage.removeItem('redirectAfterLoginByLink')
            sessionStorage.setItem('wasRedirected', 'true')
            return
        }

        if (!loadingGetSupplier && supplier?.status === SUPPLIERS_STATUS.INCOMPLETE) {
            if (supplier?.companyName) {
                // Redirect to Stripe
                dispatch(SuppliersActions.reauthenticateSupplier(supplier.supplierId))
                return
            } else {
                // Go to /register
                history.push(SUPPLIERS_ROUTES.ONBOARDING.register)
                return
            }
        }
    }, [supplier, loadingGetSupplier, history, dispatch])

    return <LoginLoader />
}

export default Onboarding
